import {useState,React,useEffect} from 'react';

const CardListACH = ({ title, list_values, height, height_type }) => {

  var boxHeight = "180px";
  if(height){
     boxHeight = height+"px";
  }

  const [cardListHeight, setCardHeight] = useState({boxHeight});

  
  
  useEffect(() => {
   
    const mainContentElement = document.querySelector('.main-content');
    
    if (mainContentElement) {
      const mainContentHeight = mainContentElement.offsetHeight -10; 
      const newChartHeight = Math.max(mainContentHeight - 380, 0)+ 18; 

      if( height_type == "dynamic"){
        setCardHeight(`${newChartHeight}px`); 

      }
     
      
      
     
    }
  }, []); 


  return (
    <div className="card card-list" style={{height:`${cardListHeight}`}}>
      <div className="card-title card-title-blue" style={{paddingBottom:"2px"}}>{title}</div>
      <div  className="media media card-title-blue"  style={{paddingTop:0,paddingRight:"23px"}}>
              <span className="title fw-600">Name</span>
              <span className='fw-600' style={{width:"80px", textAlign:"right"}}>Ach%</span>
              <span   style={{width:"80px", textAlign:"right"}} className='fw-600'>Gth%</span>
            </div>
      {list_values && list_values.length > 0 ? (
        <div className="media-list media-list-hover media-list-divided scrollable">
           
          {list_values.map((item, index) => (
            <div key={index} className="media media-single">
              <span className="title">{item.name}</span>
              <span style={{width:"80px", textAlign:"right"}}>{formatNumber(item.ach_per)}</span>
              <span style={{width:"80px", textAlign:"right"}}>{formatNumber(item.gth_per)}</span>
            </div>
          ))}
        </div>
      ) : (
        <div className="media-list-placeholder" style={{padding:`10px`}}>No items to display</div>
      )}
    </div>
  );
};


const formatNumber = (numericString) => {
   
  const number = parseFloat(numericString);
  if (!isNaN(number)) {
    const formatter = new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 2, 
      maximumFractionDigits: 2, 
    });
    
    var formattedNumber = formatter.format(number);
    const withoutCommas = formattedNumber.replace(/,/g, '');

    return withoutCommas;
  }

  return numericString; // Return original string if conversion fails
};



export default CardListACH;
